import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ReactCountryFlag from "react-country-flag";
import LoadingPage from './components/LoadingPage';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import { useTranslation } from 'react-i18next';
import './i18n';  // Importe o i18n diretamente, mas não o atribua a uma variável

// Lazy load dos componentes
const GlobalSigns = lazy(() => import('./pages/global_signs'));
const Prediction = lazy(() => import('./pages/prediction'));
const BrazilSigns = lazy(() => import('./pages/brazil_signs'));
const AboutUs = lazy(() => import('./pages/AboutUs'));

// Crie um tema personalizado
const theme = createTheme({
  palette: {
    mode: 'dark', // Isso definirá um tema escuro
    primary: {
      main: '#90caf9', // Um azul claro
    },
    secondary: {
      main: '#f48fb1', // Um rosa claro
    },
    background: {
      default: '#121212', // Um cinza muito escuro
      paper: '#1e1e1e', // Um cinza escuro para os componentes de papel
    },
  },
});

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { t, i18n } = useTranslation();  // Use o hook useTranslation para obter i18n

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <Router>
          <div className="App">
            <header className="top-menu">
              <div className="left-section">
                <img src="/logo.png" alt="GEOPREDICT" className="logo" />
                <div className="title-container">
                  <span className="team-name">GEOPREDICT</span>
                  <span className="main-title">  | {t('title')}</span>
                </div>
              </div>
              <nav>
                <ul>
                  <li><Link to="/">{t('menu.brazilSigns')}</Link></li>
                  <li><Link to="/global_signs">{t('menu.globalSigns')}</Link></li>
                  <li><Link to="/prediction">{t('menu.education')}</Link></li>
                  <li><Link to="/about">{t('menu.about')}</Link></li>
                </ul>
              </nav>
              <div className="language-selector">
                <ReactCountryFlag
                  countryCode={i18n.language === 'pt' ? 'US' : 'BR'}
                  svg
                  style={{
                    width: '2em',
                    height: '2em',
                    cursor: 'pointer'
                  }}
                  title={i18n.language === 'pt' ? 'Switch to English' : 'Mudar para Português'}
                  onClick={() => changeLanguage(i18n.language === 'pt' ? 'en' : 'pt')}
                />
              </div>
            </header>

            <main className="content">
              <Suspense fallback={<LoadingPage />}>
                <Routes>
                  <Route path="/global_signs" element={<GlobalSigns />} />
                  <Route path="/prediction" element={<Prediction />} />
                  <Route path="/" element={<BrazilSigns />} />
                  <Route path="/about" element={<AboutUs />} />
                </Routes>
              </Suspense>
            </main>

            {isLoading && <LoadingPage />}
          </div>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
